import { find, includes } from 'lodash';

export default function(logic, { questions }) {
  let isAllowed = true;
  
  logic.forEach((logicItem) => {
    let dependAnswer = find(questions, {_id: logicItem.questionId});
    
    if(dependAnswer) {
      if(dependAnswer.type == 'options') {
        let option = find(dependAnswer.content.options, {_id: logicItem.answer});

        if(option) {
          let isContains = includes(dependAnswer.answer.options, option.text);

          if(
            (!isContains && logicItem.statement == 'equals')
            || (isContains && logicItem.statement == 'not_equals')
          ) {
            isAllowed = false;
          }
        }
      }
      
      if(dependAnswer.type == 'stars5' || dependAnswer.type == 'grades10' || dependAnswer.type == 'emotions') {
        let number;

        switch (dependAnswer.type) {
          case 'stars5':
            number = parseInt(dependAnswer.answer.stars);
            break;
          case 'grades10':
            number = parseInt(dependAnswer.answer.grade);
            break;
          case 'emotions':
            number = parseInt(dependAnswer.answer.emotion);
            break;
        }
        
        let statement;

        switch (logicItem.statement) {
          case 'equals':
            statement = (number == logicItem.answer);
            break;
          case 'not_equals':
            statement = (number != logicItem.answer);
            break;
          case 'more_equals':
            statement = (number >= logicItem.answer);
            break;
          case 'less_equals':
            statement = (number <= logicItem.answer);
            break;
        }

        if(!statement) {
          isAllowed = false;
        }
      }

      if(dependAnswer.type == 'statement') {
        let statementWord = logicItem.answer == 1 ? 'good' : 'bad';

        if(
          (logicItem.statement == 'equals' && statementWord != dependAnswer.answer.statement)
          || (logicItem.statement == 'not_equals' && statementWord == dependAnswer.answer.statement)
        ) {
          isAllowed = false;
        }
      }
    } else {
      isAllowed = false;
    }
  });

  return isAllowed;
}
